import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const k = keyword.trim();
    if (!k) return;
    navigate(`/category/search?q=${encodeURIComponent(k)}`);
  };

  return (
    <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20banner%20of%20a%20vibrant%20manga%20city%20skyline%20with%20colorful%20comic%20books%2C%20sakura%20petals%20and%20dynamic%20light%20streaks%2C%20warm%20coral%20orange%20and%20cream%20palette%2C%20artistic%20and%20whimsical%2C%20high%20detail%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
        alt="91漫画漫画阅读平台横幅"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 max-w-5xl text-center text-background-50">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/30 text-sm">
          <i className="ri-fire-fill text-accent-400"></i>
          海量免费漫画 每日更新
        </span>
        <h1 className="mt-5 text-3xl md:text-5xl font-heading leading-tight">
          分类浏览 + 人气榜，热门推荐一网打尽
        </h1>
        <p className="mt-4 text-sm md:text-lg text-background-100 max-w-2xl mx-auto">
          热血、恋爱、奇幻、悬疑……多种分类随心切换；人气榜、完结榜、新作实时更新，快速找到你想看的漫画。
        </p>

        <form onSubmit={submit} className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center max-w-xl mx-auto rounded-full bg-background-50 p-1.5 gap-1.5">
          <div className="flex items-center gap-2 flex-1 px-3">
            <i className="ri-search-line text-foreground-500 text-lg"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索想看的漫画…"
              className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap justify-center gap-2">
          {categories.slice(0, 6).map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-xs hover:bg-primary-500 transition-colors whitespace-nowrap"
            >
              {c.name}漫画
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}